import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { MarketplaceClient, marketplaceApiRef } from './api';

export const marketplaceFrontendPlugin = createPlugin({
  id: 'marketplace-frontend',
  apis: [
    createApiFactory({
      api: marketplaceApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new MarketplaceClient({ configApi, identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const MarketplaceFrontendPage = marketplaceFrontendPlugin.provide(
  createRoutableExtension({
    name: 'MarketplaceFrontendPage',
    component: () => import('./components/HomePage').then((m) => m.HomePage),
    mountPoint: rootRouteRef,
  })
);
